import axios from 'axios';

const BASE_URL =
  (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? 'http://localhost:3000';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('seller_accessToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status as number | undefined;
    if (status === 401 && !isRefreshing) {
      isRefreshing = true;
      const refreshToken = localStorage.getItem('seller_refreshToken');
      if (refreshToken) {
        try {
          // Seller realm — /auth/refresh is the USER realm and cannot see
          // seller refresh tokens (separate Redis namespace).
          const { data } = await axios.post<{ accessToken: string }>(
            `${BASE_URL}/seller/auth/refresh`,
            { refreshToken },
          );
          localStorage.setItem('seller_accessToken', data.accessToken);
          isRefreshing = false;
          error.config.headers['Authorization'] = `Bearer ${data.accessToken}`;
          return apiClient.request(error.config);
        } catch {
          // refresh failed — fall through to redirect
        }
      }
      isRefreshing = false;
      localStorage.removeItem('seller_accessToken');
      localStorage.removeItem('seller_refreshToken');
      localStorage.removeItem('seller_user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
